import { render, staticRenderFns } from "./NewAutomation.vue?vue&type=template&id=3d71bec6&scoped=true"
import script from "./NewAutomation.vue?vue&type=script&lang=js"
export * from "./NewAutomation.vue?vue&type=script&lang=js"
import style0 from "./NewAutomation.vue?vue&type=style&index=0&id=3d71bec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71bec6",
  null
  
)

export default component.exports